import { render, staticRenderFns } from "./ProfilePictureModal.vue?vue&type=template&id=3030d4c3"
import script from "./ProfilePictureModal.vue?vue&type=script&lang=js"
export * from "./ProfilePictureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports